// AUTO-GENERATED by sync-icons — do not edit.
import type { FC, SVGProps } from 'react';
const SvgClockIcon: FC<SVGProps<SVGGElement>> = props => (
  <g {...props}>
    <path d="M13 7a1 1 0 1 0-2 0v5.968l3.36 2.8a1 1 0 1 0 1.28-1.536l-2.64-2.2z" />
    <path
      fillRule="evenodd"
      d="M22 12c0 5.523-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2s10 4.477 10 10m-2 0a8 8 0 1 1-16 0 8 8 0 0 1 16 0"
    />
  </g>
);
export default SvgClockIcon;
SvgClockIcon.displayName = 'SvgClockIcon';
